import type { Id, TableNames } from '@convex/_generated/dataModel'
import type { SystemTableNames } from 'convex/server'
import { notFound } from 'next/navigation'
import { readUnknownProperty } from '@shared/validation/narrow'

const CONVEX_ID_PATTERN = /^[a-z0-9]{32}$/

export function isValidConvexId(id: string): boolean {
 return CONVEX_ID_PATTERN.test(id)
}

export function isConvexId<TTable extends TableNames | SystemTableNames>(
  id: unknown,
): id is Id<TTable> {
  return typeof id === 'string' && CONVEX_ID_PATTERN.test(id)
}

export function parseConvexId<TTable extends TableNames>(id: string | null): Id<TTable> | null {
 return isConvexId<TTable>(id) ? id : null
}

export function validateIdOrNotFound<TTable extends TableNames>(
  id: string,
  table: TTable,
): Id<TTable> {
  void table
  if (!isConvexId<TTable>(id)) {
    notFound()
  }
  return id
}

export function readUploadedStorageId(body: unknown): Id<'_storage'> | undefined {
  const storageId = readUnknownProperty(body, 'storageId')
  return typeof storageId === 'string' && isConvexId<'_storage'>(storageId)
    ? storageId
    : undefined
}

export function requireUploadedStorageId(body: unknown): Id<'_storage'> {
  const storageId = readUploadedStorageId(body)
  if (!storageId) throw new Error('Upload response did not include a storage id')
  return storageId
}
